import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import { useLocation, useParams } from "react-router-dom";
import { getPostsById } from "../../../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import MineActiveProjectOverview from "./MineActiveProjectOverview";
import MineActiveProjectMilestones from "./MineActiveProjectMilestones";
import MineActiveProjectMessagesFiles from "./MineActiveProjectMessagesFiles";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";
import HelpSupportModal from "../../../../../../Common/HelpSupport/HelpSupportModal";

export default function MineActiveProjectAllTabs() {
  const { urlstate, setMyorderActiveprojectroute } = useRouteBaseStateContext();
  const { id } = useParams();
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  const location = useLocation();
  const Receivedorders = location.pathname.includes("receivedorders")

  const [proposalmilestones, setproposalmilestones] = useState("");
  const [activeTab, setActiveTab] = useState("Overview");
  const [theModal, setTheModal] = useState(false);

  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (Array.isArray(posts?.proposal) && posts?.is_mine == 1) {
      setproposalmilestones(posts.proposal[0]);
    } else if (Array.isArray(posts?.my_proposal) && posts?.is_mine == 0) {
      setproposalmilestones(posts.my_proposal[0]);
    }
  }, [posts]);

  useEffect(() => {
    if (urlstate?.myorderactiveprojectroute) {
      setActiveTab(urlstate?.myorderactiveprojectroute || "Overview");
    } else {
      setActiveTab("Overview");
    }
  }, [urlstate, urlstate?.myorderactiveprojectroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyorderActiveprojectroute(tab);
  };

  return (
    <div className="project-section">
      <div
        style={{
          display: "flex",
          alignItems: 'center',
          justifyContent: "space-between",
        }}
      >
        <h4>{posts?.title}</h4>
        <button className="background-button btn" onClick={() => setTheModal(true)}>
          Dispute
        </button>
      </div>
      <div className="col-12">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              data-toggle="tab"
              className={`nav-link ${activeTab == "Overview" ? "active" : ""}`}
              onClick={() => handleTabClick("Overview")}
            >
              {posts?.is_bxp ? "OTS" : "Project"} Overview
            </a>
          </li>
          <li className="nav-item">
            <a
              data-toggle="tab"
              className={`nav-link ${activeTab == "Milestones" ? "active" : ""
                }`}
              onClick={() => handleTabClick("Milestones")}
            >
              Milestones
            </a>
          </li>
          <li className="nav-item">
            <a
              data-toggle="tab"
              className={`nav-link ${activeTab == "Messages" ? "active" : ""}`}
              onClick={() => handleTabClick("Messages")}
            >
              Messages and files
            </a>
          </li>
        </ul>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "Overview" ? "active" : ""}`}
            id="Overview"
          >
            <MineActiveProjectOverview
              setActiveTab={setActiveTab}
              posts={posts}
              proposalmilestones={proposalmilestones}
            />
          </div>
          <div
            className={`tab-pane ${activeTab == "Milestones" ? "active" : ""}`}
            id="Milestones"
          >
            <MineActiveProjectMilestones
              posts={posts}
              proposalmilestones={proposalmilestones}
            />
          </div>
          <div
            className={`tab-pane ${activeTab == "Messages" ? "active" : ""}`}
            id="Messages"
          >
            <MineActiveProjectMessagesFiles
              posts={posts}
              proposalmilestones={proposalmilestones}
            />
          </div>
        </div>
        <HelpSupportModal
          theModal={theModal}
          setTheModal={setTheModal}
          data={posts}
          masterID={id}
          masterType={posts.is_bxp ? "4" : "5"}
          className="about-modal"
        />
      </div>
    </div>
  );
}
